/*
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2022-04-12 11:01:19
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-12 10:56:29
 */
import axios from 'axios';
import VueCookies from 'vue-cookies';
// import router from '../router'
// import Vue from 'vue'
import { Message } from 'element-ui';
// import { MessageBox } from 'element-ui';
import vm from '../main.js'
console.log(vm);
// 创建axios实例
const http = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000                 // 请求超时时间
});

// request拦截器
http.interceptors.request.use(config => {
  // Do something before request is sent
  // console.log(vm);
  // let token = Vue.prototype.$cookies.get('token')
  // if (token) {
  //   config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  //   config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

  // } else {
  //   if (vm.$route.name != 'login') {
  //     vm.$router.push('/login')//不在登录页，cookie中又没有token（cookie过期了），则返回登录页面，该场景出现于用户进入页面时，cookie未过期，进入页面后正好过期
  //   }
  // }


  return config;
}, error => {
  // Do something with request error
  // console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
http.interceptors.response.use(
  // response => response,

  /**
  * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
  response => {
    const res = response.data;
    // console.log(response,1);
    if (res.status != 200) {
      if (res.status == 201 && res.message.indexOf('无效token') > -1) {
        VueCookies.remove('token')
        vm.$router.push('/login')
      }
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      });
      return Promise.reject({ 'type': 'error', 'response': response.data });
    } else {
      return res;
    }
  },
  error => {
    console.log('err' + error);// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
)

export default http;



// WEBPACK FOOTER //
// ./src/api/http.js